<script lang="ts">
	//Svelte hooks
	import { onMount } from 'svelte';
	//libraries
	import { format } from 'svelte-i18n';
	//Stores
	import { edit } from 'src/stores/ui/edit_lists';
	import { network, os } from 'src/stores/session/native-bridge';
	import { discovered_devices, ongoingDiscovery } from 'src/stores/features/discovered';

	import { deviceMainFilter, devicesFilters } from 'src/stores/ui/filters';
	//Design system components
	import { CardGrid, Text, Alert, Loader } from '@Shelly/shelly-design-system';
	//Components
	import DiscoveredDevicesToolbar from './DiscoveredDevicesToolbar.svelte';
	import DiscoveredDeviceInList from './DiscoveredDeviceInList.svelte';
	import EmptyList from '../EmptyList.svelte';

	//Helpers
	import { getDeviceRoomList } from '../list-helpers';

	import { devices_config } from '@devices/index';
	import AddDeviceIp from './AddDeviceIp.svelte';

	import { init_discover_devices_android } from '../../../services/native_container_requests_android';
	import { init_discover_devices_ios } from '../../../services/native_container_requests_ios';

	import { Icon, type SelectOptionPropsType } from '@Shelly/shelly-design-system';

	export let inclusionData;

	let items = [];
	let mode = false;
	let deviceRoomListDB = [];

	let currentDeviceFilter = '';
	let currentRoomFilter: SelectOptionPropsType;

	const title = $format('discovered_list_empty_title', {
		default: `No discovered devices found`,
	});

	const description = $format('discovered_list_empty_description', {
		default:
			'There are no new Shelly devices in the local Wi-Fi network. Discovered devices are ones which are added to your Wi-Fi network but are not included in your account. Please check the Shelly device/s network configuration.',
	});

	$: items = Object.values($discovered_devices);

	onMount(() => {
		deviceRoomListDB = getDeviceRoomList();
		setCurrentFilters();
		scanNetwork();
	});

	const setCurrentFilters = () => {
		currentDeviceFilter = $deviceMainFilter;
		currentRoomFilter = $devicesFilters.rooms.find((filter) => filter.value);
	};

	const scanNetwork = () => {
		if ($network === 'wifi') {
			if (inclusionData) inclusionData.selected = undefined;
			if ($os === 'IOS') {
				init_discover_devices_ios();
			} else {
				init_discover_devices_android();
			}
			ongoingDiscovery.set(true);
			setTimeout(() => {
				ongoingDiscovery.set(false);
			}, 20000);
		}
	};
</script>

<DiscoveredDevicesToolbar bind:inclusionData bind:mode {scanNetwork} />

{#if mode}
	<AddDeviceIp bind:inclusionData />
{:else if !mode}
	<!-- Alex: bad check for now. I will rework this promise ;) -->
	{#if $network !== 'wifi'}
		<Alert
			type="info"
			class="mb-s"
			heading={$format('enable_location_prompt', {
				default: `Make sure the "Location" and "Local Network" are enabled in your phone's settings.`,
			})}
		/>
		<Alert
			type="warning"
			heading={$format('label_connect_to_network', {
				default: 'Please connect to a Wi-Fi network to scan for devices!',
			})}
		/>
	{:else if $ongoingDiscovery}
		<Text class="mb-s" styleType="body-small">
			{$format('discovered_loading_lable', {
				default: 'Searching for new Shelly devices in your local Wi-Fi network.',
			})}
		</Text>
		<Loader size="l" class="d-flex justify-content-center mb-m" />
	{:else if items.length == 0}
		<div class="d-flex flex-direction-column justify-content-center align-items-center">
			<Icon class="mb-m" size="l" icon="fak fa-light-microchip-slash" />
			<EmptyList type="modal" {title} {description} />
		</div>
	{:else}
		<Alert
			type="info"
			heading={$format('alert_info_discovered_description', {
				default:
					'Discovered devices are ones which are added to your Wi-Fi network but are not included in your account.',
			})}
			class="mb-m"
		/>
		<CardGrid editMode={$edit} lg={290} sm={270} gridGap="s" noPaddingBottom>
			{#each items as device, _ (device)}
				{#if typeof devices_config?.[device?.type] !== 'undefined'}
					<DiscoveredDeviceInList {device} bind:inclusionData />
				{/if}
			{/each}
		</CardGrid>
	{/if}
{/if}
